import * as Sentry from '@sentry/react'
import { configureScope } from "@sentry/react"
import { Integrations } from "@sentry/tracing"
import { SENTRY_DSN } from 'src/common/razzle-platform-components/configs'


// must initialize stenry plugin in client.ts only
export const initSentryPlugin = () => {
    if (SENTRY_DSN && process.env.NODE_ENV !== 'development') {
        // initialize sentry plugin
        Sentry.init({
            dsn: SENTRY_DSN,
            integrations: [new Integrations.BrowserTracing()],
            // contain (test|preprod|prod)
            environment: process.env.NODE_ENV,
            autoSessionTracking: true,
            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            tracesSampleRate: 1.0,
        });
        // we add this tag for make diffrence between "server side" or "client side" when the error is throwing
        configureScope(scope => { scope.setTag('runtime', 'client-side') })

    } 

}
